import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<g stroke="none"><path fill-rule="evenodd" d="M5.341 26.775c-.441.228-.986.1-1.25-.322a13.934 13.934 0 0 1-2.124-7.417c0-7.732 6.268-14 14-14s14 6.268 14 14a13.93 13.93 0 0 1-2.115 7.403c-.264.423-.812.552-1.254.321l-3.507-1.827c-.577-.3-.715-1.064-.366-1.614a8 8 0 1 0-13.504.02c.352.55.214 1.32-.367 1.62l-3.513 1.816Zm1.739-3.15-1.778.918a11.94 11.94 0 0 1-1.335-5.507c0-1.135.158-2.233.452-3.274l1.857.797a10.02 10.02 0 0 0-.309 2.477c0 1.651.402 3.213 1.113 4.588ZM15 7.074c-4.37.348-8.08 3.038-9.876 6.814l1.84.789A10.006 10.006 0 0 1 15 9.083V7.075Zm10.694 9.63c.178.748.273 1.528.273 2.331a9.965 9.965 0 0 1-1.101 4.566l1.775.925a11.942 11.942 0 0 0 1.326-5.49c0-1.084-.143-2.133-.412-3.13l-1.861.797Zm-.66-1.894 1.839-.788C25.11 10.195 21.393 7.455 17 7.08v2.01a10.007 10.007 0 0 1 8.033 5.721Z" clip-rule="evenodd"></path><path d="M14.136 20.276a1.987 1.987 0 0 1 .729-1.72l5.092-4.122c.886-.718 2.09.37 1.466 1.325l-3.533 5.396a2.05 2.05 0 0 1-1.536.92l-.063.006a1.987 1.987 0 0 1-2.155-1.805Z"></path></g>';
export var IconCreditScoreOutlineSVG = function IconCreditScoreOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
IconCreditScoreOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(IconCreditScoreOutlineSVG);